import { useAuth } from '@/contexts/AuthContext';
import { useEditMode } from '@/contexts/EditModeContext';
import { Button } from '@/components/ui/button';
import { Edit, Eye } from 'lucide-react';

export const EditModeToggle = () => {
  const { user, isEditor, loading } = useAuth();
  const { isEditMode, toggleEditMode } = useEditMode();

  console.log('🎛️ EditModeToggle render:', { loading, hasUser: !!user, isEditor });

  // Don't render until auth is fully loaded
  if (loading || !user || !isEditor) {
    console.log('❌ Not rendering toggle:', { loading, hasUser: !!user, isEditor });
    return null;
  }
  
  console.log('✅ Rendering EditModeToggle');

  return (
    <Button
      onClick={toggleEditMode}
      variant={isEditMode ? 'default' : 'outline'}
      className={`shadow-lg transition-all ${
        isEditMode ? 'bg-orange-500 hover:bg-orange-600' : ''
      }`}
    >
      {isEditMode ? (
        <>
          <Edit className="h-4 w-4 mr-2" />
          Edit Mode ON
        </>
      ) : (
        <>
          <Eye className="h-4 w-4 mr-2" />
          Edit Mode OFF
        </>
      )}
    </Button>
  );
};
